export default __webpack_public_path__ + "images/sms_b50f11.svg";